import React, { useState } from "react";
import { getUserBadges, REQUESTABLE_BADGE_TYPES } from "../../utils/badges";
import EarnBadgeModal from "../modals/EarnBadge/EarnBadgeModal";
import "./BadgePanel.css";

const BadgePanel = ({ user }) => {
  const [requestType, setRequestType] = useState(null);

  if (!user || user.role === "student") return null;

  const badges = getUserBadges(user);

  return (
    <div className="badge-panel">
      <h4 className="badge-panel-title">Badges</h4>
      <p className="badge-panel-sub">
        Verified badges build trust and get you more bookings.
      </p>

      <div className="badge-panel-list">
        {badges.map((badge) => {
          const isRequestable = REQUESTABLE_BADGE_TYPES.includes(badge.type);

          return (
            <div key={badge.type} className="badge-panel-item">
              <span className="badge-panel-icon">{badge.icon}</span>
              <div className="badge-panel-info">
                <span className="badge-panel-label">{badge.label}</span>
                {badge.status === "approved" && (
                  <span className="badge-panel-status badge-panel-status--earned">
                    Earned
                  </span>
                )}
                {badge.status === "awaiting" && (
                  <span className="badge-panel-status badge-panel-status--pending">
                    Under review
                  </span>
                )}
                {badge.status === "rejected" && (
                  <span className="badge-panel-status badge-panel-status--rejected">
                    Rejected
                  </span>
                )}
                {badge.status === "none" && !isRequestable && (
                  <span className="badge-panel-status badge-panel-status--none">
                    Not yet earned
                  </span>
                )}
              </div>

              {isRequestable &&
                (badge.status === "none" || badge.status === "rejected") && (
                  <button
                    type="button"
                    className="badge-panel-request-btn"
                    onClick={() => setRequestType(badge.type)}
                  >
                    {badge.status === "rejected" ? "Resubmit" : "Request"}
                  </button>
                )}
            </div>
          );
        })}
      </div>

      <EarnBadgeModal
        open={!!requestType}
        badgeType={requestType}
        onClose={() => setRequestType(null)}
      />
    </div>
  );
};

export default BadgePanel;
